 
 
import { DoDocObject } from './AbstractDocument';

export class PresentationDocument extends DoDocObject {
  protected getObjectType(): Realtime.Core.Document.DocumentType {
    return 'presentation';
  }

  get versions() {
    return this.data?.lifecycle?.versions || [];
  }
}
